import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shareBase } from '../config';
import { showGenericErrorModal } from '../ducks/modals';
import { projectShareIdSelector } from '../reducers/selectors';
import { Button } from './Button';
import MaterialIcon from './MaterialIcon';
import { Modal } from './Modal';
import styles from './ShareProjectModal.less';
import invariant from 'tiny-invariant';

export function ShareProjectModal({ show, onHide, shareID }) {
  const projectShareID = useSelector(projectShareIdSelector);
  const theShareId = useMemo(
    () => shareID ?? projectShareID,
    [shareID, projectShareID],
  );
  invariant(theShareId, 'ShareID missing');
  const shareLink = useMemo(
    () => `${shareBase}${theShareId}`,
    [shareBase, theShareId],
  );
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);
  const timeout = useRef(null);

  useEffect(() => {
    if (!theShareId) {
      dispatch(showGenericErrorModal());
    }
  }, [theShareId]);

  const onClickCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      setCopied(true);
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => setCopied(false), 5000);
    } catch (error) {
      console.error(error);
      dispatch(showGenericErrorModal());
    }
  }, [shareLink, dispatch]);

  const onClickOpenInNewTab = useCallback(() => {
    window.open(shareLink);
  }, [shareLink]);

  return (
    <Modal title="Share your project" show={show} onHide={onHide}>
      <div className={styles.container}>
        <Button
          onClick={onClickCopy}
          variant="primary"
          width="182px"
          className={styles.copyButton}
        >
          <MaterialIcon icon="add_link" className={styles.copyIcon} />
          {copied ? 'Copied!' : 'Copy link'}
        </Button>
        <Button onClick={onClickOpenInNewTab} variant="primary" width="182px">
          Open link in new tab
        </Button>
        <Button onClick={onHide} variant="tertiary" width="140px">
          Cancel
        </Button>
      </div>
    </Modal>
  );
}
